<template>
    <div id="main-container" class="px-0">
        <div class="scrollable-container" style="overflow-y: scroll;">
            <div class="card card-container">
                <img id="img-card" class="img-card" src="@/assets/images/logo-forgotpassword.png" />
                <h3 class="text-main font-weight-bold mt-3">{{ $t('Forgot Password') }}</h3>
                <Form @submit="handleRegister" :validation-schema="schema">
                    <div class="form-group">
                        <label for="email">{{ $t('Email Address') }}</label>
                        <Field name="email" type="email" class="form-control" />
                        <ErrorMessage name="email" class="error-feedback" />
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-main btn-block" :disabled="loading || countdown > 0">
                            <span>{{ $t('Send') }}</span>
                        </button>
                        <div class="text-center">
                            <span v-if="countdown > 0" class="text-muted">
                                {{ $t('Available again in {countdown} seconds', { countdown: countdown }) }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group pt-2">
                        <div class="d-flex justify-content-center">
                            <span class="text-center">
                                {{ $t('Don\'t have an account?') }}
                                <router-link to="/register" class="text-main">{{ $t('Register') }}</router-link>
                            </span>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "ForgotPasswordPage",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            email: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Email Address") }))
                .email(this.$t("Data is invalid!", { data: this.$t("Email Address") })),
        });

        return {
            countdown: 0,
            loading: false,
            schema,
        };
    },
    computed: {
        //
    },
    methods: {
        handleRegister(user) {
            let loader = this.$loading.show();

            this.$store.dispatch("auth/forgotPassword", user).then(
                (data) => {
                    this.$vueAlert.alert(data.message, null, 'success');
                    // Disable the resend button and start the countdown
                    this.countdown = 30;
                    const countdownInterval = setInterval(() => {
                        this.countdown--;
                        if (this.countdown === 0) {
                            clearInterval(countdownInterval);
                        }
                    }, 1000);
                    loader.hide();
                },
                (error) => {
                    this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    loader.hide();
                }
            );
        },
    },
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.card-container.card {
    max-width: 375px !important;
    padding: 40px 40px;
}

.card {
    background-color: #fff;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;

    @media screen and (max-width: 600px) {
        margin-top: 25px;
    }

    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
